<div class="container">
    <div class="header-top">
      <div class="header-left">
        <app-page-close-button (click)="goBack()"></app-page-close-button>
        <div class="title-container">
          <span class="title">
            @if (readOnlyMode) { View } @else if(masterEditingEnabled) { Edit
            } @else { Add } Commodity
          </span>
   
        </div>
      </div>
      <div class="header-right">
        <ng-container *ngIf="readOnlyMode">
          <button type="button" class="secondary_button" (click)="goBack()">
            Back
          </button>
        </ng-container>
        <ng-container *ngIf="!readOnlyMode">
          <button type="button" class="secondary_button" (click)="goBack()">
            Cancel
          </button>
          <button type="button" class="primary_button" (click)="submitMasterForm()">
            @if(masterEditingEnabled) { Update } @else { Save }
          </button>
        </ng-container>
      </div>
    </div>

  <div class="container-content">
    
    <div class="section">
      <div class="head">Basic Information</div>
  <div class="dynamicForm">

    <app-dynamic-form [formConfig]="basicInformationConfig" [formGroup]="masterForm" (onValueChange)="handleValueChange($event)"></app-dynamic-form>
  </div>
    </div>
  
    @if (this.masterForm.get('hasImdgDetails')?.value) {
      <div class="section">
        <div class="head tabs">
          <div class="tab">IMDG Class Details</div>
        </div>
        <div class="dynamicForm">

          <app-dynamic-form [formConfig]="imdgDetailsConfig" [formGroup]="imdgForm"></app-dynamic-form>
        </div>
      </div>
    }
  
    </div>


</div>
